namespace Gamification.Gamification {
    export namespace UtentiProdottiParametriGlobaliService {
        export const baseUrl = 'Gamification/UtentiProdottiParametriGlobali';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiParametriGlobaliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiParametriGlobaliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiParametriGlobaliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiParametriGlobaliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiParametriGlobali/Create",
            Update = "Gamification/UtentiProdottiParametriGlobali/Update",
            Delete = "Gamification/UtentiProdottiParametriGlobali/Delete",
            Retrieve = "Gamification/UtentiProdottiParametriGlobali/Retrieve",
            List = "Gamification/UtentiProdottiParametriGlobali/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiParametriGlobaliService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
